import styled, {css} from 'styled-components';

const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 400px;
    margin-left: 10px;
    margin-right: 10px;
    
    @media (max-width: 400px) {
        min-width: 360px;
    }
    
    @media (max-width: 400px) {
        min-width: 360px;
    }
    
    @media (max-width: 360px) {
        min-width: 200px;
    }
    
    @media screen and (orientation:landscape) {
        margin-left: 30px;
    }
        
    @media (max-width: 1140px) {
        align-items: center;
    }
    
    ${({type}) => type === 'contact' && css`
        margin-top: 70px;  
        
        @media (max-width: 1140px) {
            margin-top: 0;
            padding-left: 0;
        }
        
        padding-left: 50px;
    `}
`;

export default SectionContainer;
